const { getElements, getElement } = window.BAO.Utils

export class ProductUpsells extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.renderProducts().then(() => {
      if (
        this.dataset.onloadVariantSize &&
        this.dataset.onloadVariantAvailable === 'false'
      ) {
        this.filterRenderedProducts(
          this.dataset.onloadVariantSize,
          this.dataset.onloadVariantAvailable === 'true',
        )
      }
    })
  }

  async renderProducts () {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${this.productId}&section_id=product-upsells&intent=related`,
      )

      if (!response.ok) {
        throw new Error(
          `Recommendations request failed with status ${response.status}`,
        )
      }

      const text = await response.text()

      this.innerHTML = text

      await this.updateRegiosPrices()
    } catch (error) {
      console.error('[ProductUpsells] Could not render products', error)
    }
  }

  async updateRegiosPrices () {
    const dataElement = this.querySelector(
      '[data-product-upsells-el="regios-products"]',
    )

    if (!dataElement) return

    let products

    try {
      products = JSON.parse(dataElement.textContent)
    } catch (error) {
      console.warn(
        '[ProductUpsells] Could not parse Regios product data',
        error,
      )

      return
    }

    const api = await this.getRegiosApi()

    if (!api) return

    for (const product of products) {
      const productElement = this.querySelector(
        `[data-regios-dopp-generic-product-id="${product.productId}"]`,
      )

      if (!productElement) continue

      const priceContainer = productElement.querySelector(
        '.regios-dopp-generic-price-container',
      )
      const salePriceElement = productElement.querySelector(
        '.regios-dopp-generic-price-item--sale',
      )
      const regularPriceElement = productElement.querySelector(
        '.regios-dopp-generic-price-item--regular',
      )

      if (!priceContainer || !salePriceElement || !regularPriceElement) {
        continue
      }

      try {
        const { salePrice, regularPrice } =
          await api.calculateDiscountedPrices(product)

        const isDiscounted = salePrice.amount < regularPrice.amount

        salePriceElement.textContent = salePrice.formatted

        if (isDiscounted) {
          regularPriceElement.textContent = regularPrice.formatted
          regularPriceElement.style.removeProperty('display')

          priceContainer.classList.add('regios-dopp-generic-price--on-sale')
        } else {
          regularPriceElement.textContent = ''
          regularPriceElement.style.display = 'none'

          priceContainer.classList.remove('regios-dopp-generic-price--on-sale')
        }
      } catch (error) {
        console.warn(
          `[ProductUpsells] Could not calculate Regios price for product ${product.productId}`,
          error,
        )
      }
    }
  }

  getRegiosApi () {
    if (window.RegiosDOPP?.api?.v0) {
      return Promise.resolve(window.RegiosDOPP.api.v0)
    }

    return new Promise((resolve) => {
      const timeout = window.setTimeout(() => {
        resolve(null)
      }, 5000)

      window.addEventListener(
        'regios-dopp:api-initialized',
        (event) => {
          window.clearTimeout(timeout)

          resolve(event.detail.api)
        },
        { once: true },
      )
    })
  }

  filterRenderedProducts (size, available) {
    if (available === true) {
      this.setAttribute('aria-hidden', true)

      return
    }

    const products = getElements('[data-product-upsell-el="product"]', {
      context: this,
    })

    let matchingProductCount = 0

    products.forEach((product) => {
      const productAvailabilityData = JSON.parse(
        product.dataset.sizeAvailability,
      )
      const slide = product.closest(
        '[data-product-upsells-carousel-el="slide"]',
      )
      const hasSize = productAvailabilityData[size] === 'true'

      if (hasSize && matchingProductCount < parseInt(this.limit, 10)) {
        if (slide) slide.setAttribute('aria-hidden', false)

        matchingProductCount++
      } else {
        if (slide) slide.setAttribute('aria-hidden', true)
      }
    })

    this.setAttribute('aria-hidden', matchingProductCount === 0)

    const carousel = getElement('product-upsells-carousel', {
      context: this,
    })

    if (carousel) carousel.refresh()
  }

  get productId () {
    return this.dataset.productId
  }

  get limit () {
    return this.dataset.limit
  }
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells)
}
